import styled from 'styled-components';
import { Box, Card } from 'rebass';

export const SideTabs = styled(Box)`
	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
	padding: 24px;
	height: calc(100vh - 160px);
	min-width: 310px;
	max-width: 350px;
	overflow: auto;
`;

export const ContentTabs = styled(Box)`
	padding: 24px;
	height: calc(100vh - 160px);
	overflow: auto;
`;

export const ActiveTabCircle = styled(Box)`
	background-color: #2b80b9;
	border-radius: 50%;
	border: 1px solid #2b80b9;
	width: 12px;
	height: 12px;
	margin-right: 14px;
`

export const InactiveTabCircle = styled(Box)`
	background-color: white;
	border-radius: 50%;
	border: 1px solid white;
	width: 12px;
	height: 12px;
	margin-right: 14px;
`

export const ScheduleCard = styled(Card)`
	box-sizing: border-box;
	margin: 0 20px 20px 0;
	padding: 18px;
	border-radius: 6px;
	box-shadow: 0 0 6px rgba(0,0,0,.16);
	min-width: 300px;
`;

export const TitleSection = styled(Card)`
	//height: 200px;
	min-height: 74px;
`

TitleSection.defaultProps = {
	boxShadow: 'main',
	width: 1,
	py: 3,
	px: 4,
	bg: 'white'
};